import type {ReactNode} from 'react';
import {toast, type ToastContentProps} from 'react-toastify';

import styles from './styles.module.css';

interface Props {
  icon?: ReactNode;
  message?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  title?: string;
}

export const CustomToast = ({
  data,
  toastProps: {toastId},
}: ToastContentProps<Props>) => {
  const {icon, message, onClick, title} = data;

  const onClickCB = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (onClick) {
      onClick(e);

      toast.dismiss(toastId);
    }
  };

  return (
    <div
      className={`CustomToast ${styles.customToastNotification} ${
        onClick ? styles.isClickable : ''
      }`}
      onClick={onClickCB}
    >
      {icon ? <div className={styles.toastIcon}>{icon}</div> : null}
      <div className={styles.toastContainer}>
        {title ? <div className={styles.toastTitle}>{title}</div> : null}
        {message ? <div className={styles.toastMessage}>{message}</div> : null}
      </div>
    </div>
  );
};
